import { render, staticRenderFns } from "./HistoricoDomicilios.vue?vue&type=template&id=6f32ab0a&"
import script from "./HistoricoDomicilios.vue?vue&type=script&lang=js&"
export * from "./HistoricoDomicilios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports